(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-own-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pawfresh-build-your-bundle')) {
    class PawfreshBuildYourBundle extends HTMLElement {
      constructor() {
        super();

        this.items = new Map();
        this.productsById = new Map();
        this.variantsById = new Map();
        this.planCatalog = new Map();

        this.deliveryKey = 'one_time';
        this.isSubmitting = false;
        this.emptyBoxText = 'Add products to start building your box.';

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.readData();

        this.emptyBoxText = this.querySelector('[data-box-empty]')?.textContent?.trim() || this.emptyBoxText;

        if (!this.data?.products?.length) return;

        this.indexData();
        this.populateDeliveryOptions();
        this.setInitialDelivery();

        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);

        this.setupMobileBar();
        this.renderAll();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleChange);

        this.teardownMobileBar();

        this.initialized = false;
      }

      get minimumItems() {
        return Math.max(1, Number.parseInt(this.dataset.minItems || '1', 10) || 1);
      }
      get totalItems() {
        let total = 0;

        this.items.forEach((item) => {
          total += item.quantity;
        });

        return total;
      }

      get deliverySelect() {
        return this.querySelector('[data-delivery-select]');
      }

      get boxItemsElement() {
        return this.querySelector('[data-box-items]');
      }

      get boxCountElement() {
        return this.querySelector('[data-box-count]');
      }

      get subtotalElement() {
        return this.querySelector('[data-box-subtotal]');
      }

      get messageElement() {
        return this.querySelector('[data-box-message]');
      }

      get errorElement() {
        return this.querySelector('[data-box-error]');
      }

      get submitButton() {
        return this.querySelector('[data-submit-box]');
      }

      get submitLabel() {
        return this.querySelector('[data-submit-label]');
      }

      readData() {
        const script = this.querySelector('[data-bundle-data]');

        if (!script?.textContent) {
          this.data = {
            products: [],
            moneyFormat: '',
          };

          return;
        }

        try {
          this.data = JSON.parse(script.textContent);
        } catch (error) {
          console.error('[PawFresh BYOB] Product data could not be parsed.', error);

          this.data = {
            products: [],
            moneyFormat: '',
          };
        }
      }

      indexData() {
        const allowedWeeks = new Set([1, 2, 3, 4, 5]);
        const groupWeeks = new Map();

        /*
         * First identify which selling-plan group contains the
         * expected Appstle frequencies.
         */
        this.data.products.forEach((product) => {
          product.variants.forEach((variant) => {
            variant.plans.forEach((plan) => {
              const weeks = this.extractWeeks(plan.name);
              const groupId = String(plan.groupId || '');

              if (!groupId || weeks === null || !allowedWeeks.has(weeks)) {
                return;
              }

              if (!groupWeeks.has(groupId)) {
                groupWeeks.set(groupId, new Set());
              }

              groupWeeks.get(groupId).add(weeks);
            });
          });
        });

        const rankedGroups = Array.from(groupWeeks.entries()).sort(
          (firstGroup, secondGroup) => secondGroup[1].size - firstGroup[1].size
        );

        /*
         * Prefer the group that contains all five expected
         * delivery frequencies.
         */
        const completeGroup = rankedGroups.find((entry) => [1, 2, 3, 4, 5].every((weeks) => entry[1].has(weeks)));

        this.activeSellingPlanGroupId = completeGroup?.[0] || rankedGroups[0]?.[0] || '';

        this.data.products.forEach((product) => {
          this.productsById.set(String(product.id), product);

          product.variants.forEach((variant) => {
            variant.productId = product.id;
            variant.planMap = new Map();

            variant.plans.forEach((plan) => {
              const weeks = this.extractWeeks(plan.name);
              const groupId = String(plan.groupId || '');

              /*
               * Never expose frequencies outside 1–5 weeks.
               */
              if (weeks === null || !allowedWeeks.has(weeks)) {
                return;
              }

              /*
               * Ignore selling plans from old or unrelated groups.
               */
              if (this.activeSellingPlanGroupId && groupId !== this.activeSellingPlanGroupId) {
                return;
              }

              const planKey = `weeks:${weeks}`;

              plan.key = planKey;
              variant.planMap.set(planKey, plan);

              if (!this.planCatalog.has(planKey)) {
                this.planCatalog.set(planKey, {
                  key: planKey,
                  label: this.createPlanLabel(plan.name),
                  weeks,
                  rawName: plan.name,
                  groupId,
                });
              }
            });

            this.variantsById.set(String(variant.id), variant);
          });
        });
      }

      populateDeliveryOptions() {
        const select = this.deliverySelect;

        if (!(select instanceof HTMLSelectElement)) return;

        const oneTimeOption = document.createElement('option');

        oneTimeOption.value = 'one_time';
        oneTimeOption.textContent = this.dataset.oneTimeLabel || 'One-time purchase';

        select.replaceChildren(oneTimeOption);

        const plans = Array.from(this.planCatalog.values()).sort((firstPlan, secondPlan) => {
          if (firstPlan.weeks !== null && secondPlan.weeks !== null) {
            return firstPlan.weeks - secondPlan.weeks;
          }

          if (firstPlan.weeks !== null) return -1;
          if (secondPlan.weeks !== null) return 1;

          return firstPlan.label.localeCompare(secondPlan.label);
        });

        plans.forEach((plan) => {
          const option = document.createElement('option');

          option.value = plan.key;
          option.textContent = plan.label;

          select.append(option);
        });
      }

      setInitialDelivery() {
        const defaultPurchase = this.dataset.defaultPurchase || 'one_time';

        const defaultWeeks = Number.parseInt(this.dataset.defaultWeeks || '2', 10) || 2;

        const preferredKey = `weeks:${defaultWeeks}`;

        if (defaultPurchase === 'subscription' && this.planCatalog.has(preferredKey)) {
          this.deliveryKey = preferredKey;
        } else if (defaultPurchase === 'subscription' && this.planCatalog.size > 0) {
          this.deliveryKey = Array.from(this.planCatalog.keys())[0];
        } else {
          this.deliveryKey = 'one_time';
        }

        if (this.deliverySelect instanceof HTMLSelectElement) {
          this.deliverySelect.value = this.deliveryKey;
        }
      }

      handleChange(event) {
        const target = event.target;

        if (!(target instanceof HTMLElement)) return;

        if (target.matches('[data-product-variant-select]')) {
          const card = target.closest('[data-product-card]');
          this.renderCard(card);
          return;
        }

        if (target.matches('[data-delivery-select]')) {
          this.deliveryKey = target.value || 'one_time';
          this.hideError();
          this.renderAll();
        }
      }

      handleClick(event) {
        const target = event.target instanceof Element ? event.target : null;

        if (!target) return;

        const addButton = target.closest('[data-card-add]');
        const cardMinus = target.closest('[data-card-minus]');
        const cardPlus = target.closest('[data-card-plus]');
        const boxMinus = target.closest('[data-box-minus]');
        const boxPlus = target.closest('[data-box-plus]');
        const boxRemove = target.closest('[data-box-remove]');
        const submitButton = target.closest('[data-submit-box]');

        const mobileViewBoxButton = target.closest('[data-mobile-view-box]');

        if (addButton) {
          const card = addButton.closest('[data-product-card]');
          const variantId = this.getCardVariantId(card);

          this.adjustItem(variantId, 1);
          return;
        }

        if (cardMinus || cardPlus) {
          const card = target.closest('[data-product-card]');
          const variantId = this.getCardVariantId(card);

          this.adjustItem(variantId, cardPlus ? 1 : -1);

          return;
        }

        if (boxMinus || boxPlus || boxRemove) {
          const itemElement = target.closest('[data-box-item]');
          const variantId = itemElement?.dataset.variantId || '';

          if (boxRemove) {
            this.removeItem(variantId);
          } else {
            this.adjustItem(variantId, boxPlus ? 1 : -1);
          }

          return;
        }
        if (mobileViewBoxButton) {
          this.scrollToBox();
          return;
        }

        if (submitButton) {
          this.submitBox();
        }
      }

      getCardVariantId(card) {
        if (!(card instanceof HTMLElement)) return '';

        const selector = card.querySelector('[data-product-variant-select]');

        return selector?.value ? String(selector.value) : '';
      }

      adjustItem(variantId, change) {
        const variant = this.variantsById.get(String(variantId));

        if (!variant || !variant.available || this.isSubmitting) {
          return;
        }

        const currentItem = this.items.get(String(variantId));

        const currentQuantity = currentItem?.quantity || 0;

        if (change > 0 && this.deliveryKey !== 'one_time' && !variant.planMap.has(this.deliveryKey)) {
          this.showError('This product is not available for the selected delivery frequency.');

          return;
        }

        const nextQuantity = currentQuantity + change;

        if (nextQuantity <= 0) {
          this.items.delete(String(variantId));
        } else {
          this.items.set(String(variantId), {
            productId: String(variant.productId),
            variantId: String(variant.id),
            quantity: nextQuantity,
          });
        }

        this.hideError();
        this.renderAll();
      }

      removeItem(variantId) {
        this.items.delete(String(variantId));
        this.hideError();
        this.renderAll();
      }

      renderAll() {
        this.updateDeliveryAvailability();

        this.querySelectorAll('[data-product-card]').forEach((card) => {
          this.renderCard(card);
        });

        this.renderBox();
        this.renderSummary();
      }

      renderCard(card) {
        if (!(card instanceof HTMLElement)) return;

        const variantId = this.getCardVariantId(card);
        const variant = this.variantsById.get(String(variantId));

        if (!variant) return;

        const product = this.productsById.get(String(variant.productId));

        const image = card.querySelector('[data-card-image]');
        const price = card.querySelector('[data-card-price]');

        const subscriptionNote = card.querySelector('[data-card-subscription-note]');

        const addButton = card.querySelector('[data-card-add]');

        const quantityControl = card.querySelector('[data-card-quantity]');

        const quantityValue = card.querySelector('[data-card-quantity-value]');

        const minusButton = card.querySelector('[data-card-minus]');

        const plusButton = card.querySelector('[data-card-plus]');

        const status = card.querySelector('[data-card-status]');

        const selectedItem = this.items.get(String(variant.id));

        const quantity = selectedItem?.quantity || 0;

        const selectedPlan = this.getPlan(variant);

        const planCompatible = this.deliveryKey === 'one_time' || Boolean(selectedPlan);

        const unitPrice = this.getUnitPrice(variant);

        if (image instanceof HTMLImageElement && variant.image) {
          if (image.src !== variant.image) {
            image.src = variant.image;
          }

          image.removeAttribute('srcset');

          image.alt = [product?.title || '', variant.label || ''].join(' ').trim();
        }

        if (price) {
          price.textContent = this.formatMoney(unitPrice);
        }

        if (subscriptionNote) {
          const showSubscriptionPrice = this.deliveryKey !== 'one_time' && Boolean(selectedPlan);

          subscriptionNote.hidden = !showSubscriptionPrice;
        }

        if (addButton instanceof HTMLButtonElement) {
          addButton.hidden = quantity > 0;

          addButton.disabled = !variant.available || !planCompatible || this.isSubmitting;
        }

        if (quantityControl) {
          quantityControl.hidden = quantity === 0;
        }

        if (quantityValue) {
          quantityValue.textContent = String(quantity);
        }

        if (minusButton instanceof HTMLButtonElement) {
          minusButton.disabled = quantity === 0 || this.isSubmitting;
        }

        if (plusButton instanceof HTMLButtonElement) {
          plusButton.disabled = !variant.available || !planCompatible || this.isSubmitting;
        }

        if (status) {
          let message = '';

          if (!variant.available) {
            message = 'This size is currently sold out.';
          } else if (!planCompatible) {
            message = 'Not available for the selected delivery frequency.';
          }

          status.hidden = !message;
          status.textContent = message;
        }
      }

      updateDeliveryAvailability() {
        const select = this.deliverySelect;

        if (!(select instanceof HTMLSelectElement)) return;

        Array.from(select.options).forEach((option) => {
          if (option.value === 'one_time') {
            option.disabled = false;
            return;
          }

          option.disabled = !this.allItemsSupportPlan(option.value);
        });

        select.value = this.deliveryKey;

        const note = this.querySelector('[data-delivery-note]');

        if (!note) return;

        const currentPlan = this.planCatalog.get(this.deliveryKey);

        note.hidden = this.deliveryKey === 'one_time' || !currentPlan;

        note.textContent = currentPlan ? `${currentPlan.label} applies to every product in this box.` : '';
      }

      allItemsSupportPlan(planKey) {
        if (this.items.size === 0) return true;

        return Array.from(this.items.values()).every((item) => {
          const variant = this.variantsById.get(String(item.variantId));

          return Boolean(variant?.planMap?.has(planKey));
        });
      }

      renderBox() {
        const container = this.boxItemsElement;

        if (!container) return;

        if (this.items.size === 0) {
          container.innerHTML = `
            <div class="pf-byob-box__empty" data-box-empty>
              ${this.escapeHTML(this.emptyBoxText)}
            </div>
          `;

          return;
        }

        container.innerHTML = Array.from(this.items.values())
          .map((item) => {
            const variant = this.variantsById.get(String(item.variantId));

            const product = this.productsById.get(String(item.productId));

            if (!variant || !product) return '';

            const unitPrice = this.getUnitPrice(variant);

            const linePrice = unitPrice * item.quantity;

            const image = variant.image || product.featuredImage || '';

            const imageMarkup = image
              ? `
                  <img
                    src="${this.escapeAttribute(image)}"
                    alt="${this.escapeAttribute(product.title)}"
                    loading="lazy"
                  >
                `
              : '';

            return `
                <div
                  class="pf-byob-box-item"
                  data-box-item
                  data-variant-id="${this.escapeAttribute(item.variantId)}"
                >
                  <div class="pf-byob-box-item__image">
                    ${imageMarkup}
                  </div>

                  <div class="pf-byob-box-item__content">
                    <p class="pf-byob-box-item__title">
                      ${this.escapeHTML(product.title)}
                    </p>

                    <span class="pf-byob-box-item__variant">
                      ${this.escapeHTML(variant.label)}
                    </span>
                  </div>

                  <button
                    type="button"
                    class="pf-byob-box-item__remove"
                    data-box-remove
                    aria-label="Remove ${this.escapeAttribute(product.title)} ${this.escapeAttribute(variant.label)}"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M5 5l10 10M15 5 5 15"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>

                  <div class="pf-byob-box-item__controls">
                    <button
                      type="button"
                      class="pf-byob-box-item__control"
                      data-box-minus
                      aria-label="Decrease quantity"
                    >
                      <svg
                        viewBox="0 0 20 20"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M4 10h12"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>

                    <span class="pf-byob-box-item__quantity">
                      ${item.quantity}
                    </span>

                    <button
                      type="button"
                      class="pf-byob-box-item__control"
                      data-box-plus
                      aria-label="Increase quantity"
                    >
                      <svg
                        viewBox="0 0 20 20"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M10 4v12M4 10h12"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>
                  </div>

                  <strong class="pf-byob-box-item__price">
                    ${this.formatMoney(linePrice)}
                  </strong>
                </div>
              `;
          })
          .join('');
      }

      renderSummary() {
        const validation = this.validateBox();
        const subtotal = this.calculateSubtotal();

        const remaining = Math.max(0, this.minimumItems - this.totalItems);

        if (this.boxCountElement) {
          this.boxCountElement.textContent = `${this.totalItems} selected`;
        }

        if (this.subtotalElement) {
          this.subtotalElement.textContent = this.formatMoney(subtotal);
        }

        if (this.submitButton instanceof HTMLButtonElement) {
          this.submitButton.disabled = !validation.valid || this.isSubmitting;

          this.submitButton.dataset.loading = this.isSubmitting ? 'true' : 'false';
        }

        if (this.submitLabel) {
          if (this.isSubmitting) {
            this.submitLabel.textContent = 'Adding your box…';
          } else if (this.totalItems === 0) {
            this.submitLabel.textContent = this.dataset.emptyButtonLabel || 'Start Building Your Box';
          } else if (remaining > 0) {
            this.submitLabel.textContent = `Add ${remaining} more ${remaining === 1 ? 'item' : 'items'}`;
          } else {
            this.submitLabel.textContent = this.dataset.finalButtonLabel || 'Add Box to Cart';
          }
        }

        this.showMessage(validation.message);
        this.syncMobileBar();
      }

      validateBox() {
        if (this.totalItems === 0) {
          return {
            valid: false,
            message: 'Choose products to start building your box.',
          };
        }

        if (this.totalItems < this.minimumItems) {
          const remaining = this.minimumItems - this.totalItems;

          const template = this.dataset.minimumMessage || 'Add {count} more items to continue.';

          return {
            valid: false,
            message: template.replace('{count}', String(remaining)),
          };
        }

        if (this.deliveryKey !== 'one_time' && !this.allItemsSupportPlan(this.deliveryKey)) {
          return {
            valid: false,
            message: 'One or more products do not support the selected delivery frequency.',
          };
        }

        return {
          valid: true,
          message: 'Your box is ready to add to the cart.',
        };
      }

      calculateSubtotal() {
        let subtotal = 0;

        this.items.forEach((item) => {
          const variant = this.variantsById.get(String(item.variantId));

          if (!variant) return;

          subtotal += this.getUnitPrice(variant) * item.quantity;
        });

        return subtotal;
      }

      getPlan(variant) {
        if (!variant || this.deliveryKey === 'one_time') {
          return null;
        }

        return variant.planMap.get(this.deliveryKey) || null;
      }

      getUnitPrice(variant) {
        const plan = this.getPlan(variant);

        return Number(plan?.price ?? variant?.price ?? 0);
      }

      createPlanKey(name) {
        const weeks = this.extractWeeks(name);

        /*
         * PawFresh subscriptions support only 1–5 weeks.
         * Reject legacy, unrelated or incorrectly attached plans.
         */
        if (weeks === null || weeks < 1 || weeks > 5) {
          return '';
        }

        return `weeks:${weeks}`;
      }

      extractWeeks(name) {
        const normalized = String(name || '').toLowerCase();

        const numbered = normalized.match(/(\d+)\s*(?:week|weeks)/i);

        if (numbered) {
          return Number.parseInt(numbered[1], 10);
        }

        if (/every\s+(?:one\s+)?week/.test(normalized)) {
          return 1;
        }

        return null;
      }

      createPlanLabel(name) {
        const weeks = this.extractWeeks(name);

        const prefix = this.dataset.subscriptionPrefix || 'Deliver every';

        if (weeks !== null) {
          return `${prefix} ${weeks} ${weeks === 1 ? 'week' : 'weeks'}`;
        }

        return String(name || 'Subscription');
      }

      async submitBox() {
        if (this.isSubmitting) return;

        const validation = this.validateBox();

        if (!validation.valid) {
          this.showError(validation.message);
          return;
        }

        this.isSubmitting = true;
        this.hideError();
        this.renderAll();

        const boxId = `pawfresh-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

        const selectedPlan = this.planCatalog.get(this.deliveryKey);

        const lines = Array.from(this.items.values()).map((item) => {
          const variant = this.variantsById.get(String(item.variantId));

          const line = {
            id: Number(item.variantId),
            quantity: item.quantity,
            properties: {
              'Build Your Own Bundle': 'Yes',
              _pawfresh_box_id: boxId,
            },
          };

          if (this.deliveryKey !== 'one_time') {
            const plan = variant?.planMap.get(this.deliveryKey);

            if (plan) {
              line.selling_plan = Number(plan.id);

              line.properties._pawfresh_delivery = selectedPlan?.label || plan.name;
            }
          }

          return line;
        });

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((component) => component.dataset.sectionId)
          .filter(Boolean);

        if (!sectionIds.includes('cart-drawer-section')) {
          sectionIds.push('cart-drawer-section');
        }

        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: lines,
              sections: Array.from(new Set(sectionIds)).join(','),
              sections_url: window.location.pathname,
            }),
          });

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'The box could not be added to the cart.');
          }

          this.replaceReturnedSections(result.sections || {});

          const ajaxCart = await this.fetchAjaxCart().catch(() => null);

          this.dispatchCartUpdate(ajaxCart, lines, result.sections || {});

          this.items.clear();
          this.renderAll();

          await this.openCart();
        } catch (error) {
          console.error('[PawFresh BYOB] Add to cart failed.', error);

          this.showError(error?.message || 'The box could not be added. Please try again.');
        } finally {
          this.isSubmitting = false;
          this.renderAll();
        }
      }

      async fetchAjaxCart() {
        const response = await fetch(`${this.dataset.cartUrl || '/cart'}.js`, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('The updated cart could not be read.');
        }

        return response.json();
      }

      dispatchCartUpdate(ajaxCart, lines, sections) {
        const target = document.querySelector('theme-drawer#cart-drawer cart-items-component') || this;

        const event = new CustomEvent('shopify:cart:lines-update', {
          bubbles: true,
          composed: true,
        });

        event.action = 'add';
        event.context = 'product';

        event.lines = lines.map((line) => ({
          merchandiseId: String(line.id),
          quantity: line.quantity,
        }));

        const cart = ajaxCart
          ? {
              ...ajaxCart,
              totalQuantity: ajaxCart.item_count,
            }
          : null;

        event.promise = Promise.resolve({
          cart,
          detail: {
            sections,
            items: ajaxCart?.items || [],
            itemCount: ajaxCart?.item_count || 0,
            source: 'pawfresh-build-your-bundle',
          },
        });

        target.dispatchEvent(event);
      }

      replaceReturnedSections(sections) {
        Object.entries(sections).forEach(([sectionId, html]) => {
          if (!html) return;

          const currentSection = document.getElementById(`shopify-section-${sectionId}`);

          if (!currentSection) return;

          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');

          const updatedSection = parsedDocument.getElementById(`shopify-section-${sectionId}`);

          if (updatedSection) {
            currentSection.replaceWith(updatedSection);
          } else {
            currentSection.innerHTML = html;
          }
        });
      }

      async openCart() {
        if (window.Shopify?.actions?.openCart) {
          await window.Shopify.actions.openCart();
          return;
        }

        const drawer = document.querySelector('theme-drawer#cart-drawer');

        if (drawer) {
          await customElements.whenDefined('theme-drawer');

          drawer.open?.();
          return;
        }

        window.location.href = this.dataset.cartUrl || '/cart';
      }
      setupMobileBar() {
        this.sectionInViewport = true;

        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

        this.handleMobileMediaChange = () => {
          this.updateMobileBarVisibility();
        };

        if (typeof this.mobileMediaQuery.addEventListener === 'function') {
          this.mobileMediaQuery.addEventListener('change', this.handleMobileMediaChange);
        } else if (typeof this.mobileMediaQuery.addListener === 'function') {
          this.mobileMediaQuery.addListener(this.handleMobileMediaChange);
        }

        if ('IntersectionObserver' in window) {
          this.mobileSectionObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];

              this.sectionInViewport = Boolean(entry?.isIntersecting);

              this.updateMobileBarVisibility();
            },
            {
              root: null,
              threshold: 0.01,
            }
          );

          this.mobileSectionObserver.observe(this);
        }

        this.syncMobileBar();
        this.updateMobileBarVisibility();
      }

      teardownMobileBar() {
        this.mobileSectionObserver?.disconnect();

        if (this.mobileMediaQuery && this.handleMobileMediaChange) {
          if (typeof this.mobileMediaQuery.removeEventListener === 'function') {
            this.mobileMediaQuery.removeEventListener('change', this.handleMobileMediaChange);
          } else if (typeof this.mobileMediaQuery.removeListener === 'function') {
            this.mobileMediaQuery.removeListener(this.handleMobileMediaChange);
          }
        }

        if (this.mobileFlashTimer) {
          window.clearTimeout(this.mobileFlashTimer);
        }

        this.mobileSectionObserver = null;
        this.mobileMediaQuery = null;
        this.handleMobileMediaChange = null;
      }

      updateMobileBarVisibility() {
        const mobileBar = this.querySelector('[data-mobile-bar]');

        if (!mobileBar) return;

        const isMobile = this.mobileMediaQuery?.matches === true;

        const shouldShow = isMobile && this.sectionInViewport !== false;

        mobileBar.hidden = !shouldShow;
      }

      syncMobileBar() {
        const countElement = this.querySelector('[data-mobile-count]');

        const totalElement = this.querySelector('[data-mobile-total]');

        const button = this.querySelector('[data-mobile-view-box]');

        if (countElement) {
          countElement.textContent = `Selected ${this.totalItems}`;
        }

        if (totalElement) {
          totalElement.textContent = this.formatMoney(this.calculateSubtotal());
        }

        if (button instanceof HTMLButtonElement) {
          button.disabled = this.totalItems === 0 || this.isSubmitting;
        }

        this.updateMobileBarVisibility();
      }

      scrollToBox() {
        const box = this.querySelector('.pf-byob-box');

        if (!box) return;

        const sectionElement = this.closest('.pf-byob');

        const computedStyles = sectionElement ? window.getComputedStyle(sectionElement) : null;

        const configuredOffset = Number.parseFloat(computedStyles?.getPropertyValue('--pf-byob-sticky-top') || '0');

        const stickyOffset = Number.isFinite(configuredOffset) && configuredOffset > 0 ? configuredOffset : 90;

        const destination = box.getBoundingClientRect().top + window.scrollY - stickyOffset - 12;

        window.scrollTo({
          top: Math.max(0, destination),
          behavior: 'smooth',
        });

        box.classList.remove('is-flash');

        requestAnimationFrame(() => {
          box.classList.add('is-flash');
        });

        if (this.mobileFlashTimer) {
          window.clearTimeout(this.mobileFlashTimer);
        }

        this.mobileFlashTimer = window.setTimeout(() => {
          box.classList.remove('is-flash');
        }, 850);
      }

      showMessage(message) {
        if (this.messageElement) {
          this.messageElement.textContent = message || '';
        }
      }

      showError(message) {
        if (!this.errorElement) return;

        this.errorElement.textContent = message || '';

        this.errorElement.hidden = !message;
      }

      hideError() {
        this.showError('');
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || this.data?.moneyFormat || '';

        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);

        if (!match) {
          return `$${(Number(cents || 0) / 100).toFixed(2)}`;
        }

        const placeholder = match[1];

        let precision = 2;
        let thousands = ',';
        let decimal = '.';

        if (placeholder.includes('no_decimals')) {
          precision = 0;
        }

        if (placeholder.includes('comma_separator')) {
          thousands = '.';
          decimal = ',';
        }

        if (placeholder.includes('space_separator')) {
          thousands = ' ';
          decimal = ',';
        }

        const value = (Number(cents || 0) / 100).toFixed(precision);

        const parts = value.split('.');

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

        const amount = precision > 0 ? `${parts[0]}${decimal}${parts[1]}` : parts[0];

        return format.replace(match[0], amount);
      }

      escapeHTML(value) {
        return String(value ?? '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      escapeAttribute(value) {
        return this.escapeHTML(value);
      }
    }

    customElements.define('pawfresh-build-your-bundle', PawfreshBuildYourBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
